import { useQueryClient } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

import { CHAVE_DA_SESSAO_DO_INSCRITO } from './api';
import { DESTINO_DEPOIS_DE_ENTRAR } from './EntrarPage';
import { PortaoDeIdentidade } from './PortaoDeIdentidade';

/**
 * Recuperar o acesso do inscrito (`/credenciados/recuperar`): redefinir a
 * senha por código enviado ao contato do cadastro do DTP, ou pelo gov.br
 * (RN-CP-12).
 *
 * É o mesmo portão do autocadastro, com a finalidade `RECUPERACAO`: a API
 * responde igual exista a conta ou não até a identidade ser comprovada, e só
 * então diz se há senha a trocar. Ao salvar a nova senha, as outras sessões
 * do CPF são encerradas e o inscrito é avisado pelo mesmo contato.
 */
export function RecuperarInscricaoPage() {
  const navegar = useNavigate();
  const cliente = useQueryClient();

  return (
    <div className="mx-auto w-full max-w-5xl px-4 py-8 sm:px-6 sm:py-12">
      <Link
        to="/credenciados/entrar"
        className="inline-flex items-center gap-1.5 text-sm text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        Voltar para a entrada
      </Link>
      <div className="mt-6">
        <PortaoDeIdentidade
          finalidade="RECUPERACAO"
          aoConfirmar={() => {
            void cliente.invalidateQueries({ queryKey: CHAVE_DA_SESSAO_DO_INSCRITO });
            navegar(DESTINO_DEPOIS_DE_ENTRAR);
          }}
        />
      </div>
    </div>
  );
}

export default RecuperarInscricaoPage;
